import i18n from "@/i18n"

export const formatNumber = (amount: number, digits = 0) => {
    const { locale } = i18n.global

    return new Intl.NumberFormat(locale.value, {
        minimumFractionDigits: digits,
    }).format(amount)
}
